import { BasePayloadMapper } from '@ps/utils';

import { AdvancedQualificationsListParams } from '../dtos/advanced-qualification.dto';

// WIP: derive from the survey's selected country/language once wired up (see
// searchLocale in localization-form.component.ts for the `${language.shortCode}_${country.shortCode}`
// formula) — hardcoded per explicit direction for this pass.
const ADVANCED_TARGETING_LOCALE = 'eng_US';

export type AdvancedQualificationsListPayload = Record<string, string>;

export class AdvancedQualificationsPayloadMapper extends BasePayloadMapper<
  AdvancedQualificationsListParams,
  AdvancedQualificationsListPayload
> {
  public toPayload(
    params: AdvancedQualificationsListParams,
  ): AdvancedQualificationsListPayload {
    const payload: AdvancedQualificationsListPayload = {
      locale: ADVANCED_TARGETING_LOCALE,
    };
    if (params.search) {
      payload['phrase'] = params.search;
    }
    if (params.categoryIds.length) {
      payload['categories'] = params.categoryIds.join(',');
    }
    return payload;
  }
}
